import React from 'react';
import ProfileBusiness from '../components/ProfilePanel/ProfileBusiness/ProfileBusiness';

export default function ProfilePage() {
  return <ProfileBusiness />;
}
